import { EnhancedPlan } from '@mm/state/interfaces/subscription';
import { centsToDollars } from '@mm/utils';
import {
  BillingPlanDefinition,
  defaultPlanValues,
  PanelPlanTypes,
} from './constants';

const freePlanDetails: BillingPlanDefinition = {
  name: 'Free Plan',
  descriptionText:
    'Facebook Messenger bot basics, list building and audience tools',
  featuresList: [
    { text: 'MobileMonkey OmniChat™' },
    { text: 'UNLIMITED CONTACTS' },
    { text: '1,000 Send Credits' },
    { text: '1 User' },
    { text: 'Coding-free chatbot builder' },
    { text: 'Chatbot templates' },
    { text: 'Audience segmentation' },
    { text: 'Website Chat Widget' },
    { text: 'Comment Guards' },
    { text: 'Email Support' },
  ],
  theme: 'white',
};

type PlanDefaults = {
  price: string;
  sendLimit: string;
  page: string;
  oldPrice: string;
};

export const billingPlanDetails = (
  planType: PanelPlanTypes,
  plan?: EnhancedPlan,
  isAnnualPrice = false,
  november2021Pricing?: boolean,
): BillingPlanDefinition => {
  if (planType === 'free') {
    return freePlanDetails;
  }
  const defaultValues: PlanDefaults = defaultPlanValues[planType];
  const price =
    (plan &&
      centsToDollars(
        isAnnualPrice ? plan.annualUnitAmountInCents : plan.unitAmountInCents,
        !isAnnualPrice,
      )) ||
    defaultValues.price;
  switch (planType) {
    case 'pro':
      return {
        name: 'OPERATOR',
        price: `$${price}/month`,
        descriptionText:
          'Advanced re-engagement/notification tools & SMS features',
        featuresList: [
          { text: '2,000 Send Credits' },
          { text: '1 User' },
          { text: 'All features in FREE, plus:', isBold: true },
          { text: 'SMS (US & Canada only)' },
          { text: 'Chat Blaster/Drip Campaigns' },
          { text: 'Custom Notifications' },
          { text: 'Remove MobileMonkey Branding' },
          { text: 'Unlimited Q&As' },
          { text: 'Business Hours' },
          { text: 'Advanced Website Chat Settings' },
        ],
        theme: 'orange',
      };
    case 'unicorn':
      return {
        name: 'STARTUP',
        price: `$${price}/month`,
        descriptionText: 'FB Ads/Zapier integrations & Analytics',
        featuresList: [
          {
            text: november2021Pricing
              ? '1,000 Send Credits'
              : '6,500 Send Credits',
          },
          { text: '1 User' },
          { text: 'All features in Operator, plus:', isBold: true },
          { text: 'Facebook Ads' },
          { text: 'Analytics' },
          { text: 'MobileMonkey API Connections' },
          { text: 'Zapier Integration' },
          { text: 'Automation Rules' },
          { text: 'Live Chat Support' },
        ],
        theme: 'blue',
      };
    case 'team':
      return {
        name: 'AGENCY',
        price: `$${price}/month`,
        descriptionText:
          'For agencies and freelancers running more than 1 Facebook page',
        featuresList: [
          { text: '10 Facebook pages' },
          { text: '100,000 Send Credits' },
          { text: `1 User` },
          { text: 'All features in Startup', isBold: true },
          { text: 'Bot Cloning & Template Sharing' },
          { text: 'Branded Sign In & Live Chat' },
          { text: 'Automated Lead Routing' },
        ],
        theme: 'green',
      };
    default:
      return {
        name: '',
        featuresList: [{ text: '' }],
        theme: null,
        descriptionText: '',
      };
  }
};
